import { useState, useEffect, useCallback } from 'react';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { apiUrl } from '../utils/apiBase';

export function useBroadcastInvites() {
  const [invites, setInvites] = useState([]);
  const authenticatedFetch = useAuthenticatedFetch();

  const load = useCallback(async () => {
    try {
      const res = await authenticatedFetch(apiUrl('/api/broadcast/invites'));
      if (res.ok) {
        const data = await res.json();
        setInvites(data.invites || []);
      }
    } catch (e) {
      // ignore
    }
  }, [authenticatedFetch]);

  useEffect(() => {
    load();
    const id = setInterval(load, 3000); // Ridotto da 10s a 3s per notifiche più rapide
    return () => clearInterval(id);
  }, [load]);

  const clearInvite = useCallback(async (token) => {
    try {
      await authenticatedFetch(apiUrl(`/api/broadcast/invites/${token}`), { method: 'DELETE' });
      // Reload invites after clearing
      load();
    } catch {}
  }, [authenticatedFetch, load]);

  return { invites, load, clearInvite };
}
